import service from "@/utils/request";

/**
 * TCL 扫码出库 - 按出库单号查询待出库列表
 * GET /uic-system/wareout/page?wareOutNo=xxx&wareOutStatus=0
 */
export function getTclWareOutPage(params) {
  return service.get("/uic-system/wareout/page", {
    params: {
      wareOutNo: params?.wareOutNo || "",
      wareOutStatus: params?.wareOutStatus ?? 0,
      current: params?.current || 1,
      size: params?.size || 20,
    },
  });
}

/**
 * TCL 扫码出库 - 出库单详情
 * POST /uic-system/api_hf/wareout/GetResourceAndNoPlsNo
 * @param {string|number} id 出库单 ID
 * body: { ids: "出库单id" }
 */
export function getTclWareOutDetail(id) {
  return service.post("/uic-system/api_hf/wareout/GetResourceAndNoPlsNo", {
    ids: String(id ?? ""),
  });
}

/**
 * TCL 扫码出库 - 按物料ID + 箱码查询库存明细
 * GET /uic-system_hf/materialstockdetail/stockWareDetail/detailBarCode
 * @param {string|number} materialId
 * @param {string} barCode
 */
export function getTclStockByBarCode(materialId, barCode) {
  return service.get(
    "/uic-system_hf/materialstockdetail/stockWareDetail/detailBarCode",
    {
      params: {
        materialId,
        barCode,
      },
    }
  );
}

/**
 * TCL 扫码出库 - 确认出库
 * POST /uic-system_hf/wareout/tclScanOutSubmitV2
 * 入参：
 * {
 *   id,
 *   wareOutDetailList: [
 *     { materialId, boxList: [{ barCode, wareOutNum }] }
 *   ]
 * }
 */
export function tclWareOutSubmit(data) {
  return service.post("/uic-system_hf/wareout/tclScanOutSubmitV2", data);
}
